import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgMoonRegular = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M19.62 16.978a.4.4 0 0 0-.081.008 7 7 0 0 1-1.34.128c-3.808 0-6.994-3.1-6.994-7.051a7.05 7.05 0 0 1 3.565-6.131.422.422 0 0 0-.132-.781A11 11 0 0 0 12.995 3c-4.997-.036-9.027 4.026-9.027 9C3.968 16.966 7.99 21 12.96 21a8.97 8.97 0 0 0 6.982-3.332.428.428 0 0 0-.321-.69m-6.66 2.093c-3.893 0-7.063-3.173-7.063-7.07 0-3.067 1.96-5.681 4.688-6.662a9 9 0 0 0-1.346 4.725c0 3.995 2.617 7.388 6.224 8.55a7 7 0 0 1-2.503.457"
    }));
export default SvgMoonRegular;
